import { BatteryDistributionPreview } from "../../BatteryDistributionPreview/BatteryDistributionPreview";
import VirtualBatteryPercentageSlider from "../../../VirtualBatteryPercentageSlider";
import useMoveVirtualBatteryContext from "../useMoveVirtualBatteryContext";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { useVirtualBatteries } from "@/components/VirtualBattery/hooks/useVirtualBatteries";

interface MoveVirtualBatteryStep2Props {

}

export const MoveVirtualBatteryStep2: FC<MoveVirtualBatteryStep2Props> = ({
  // nextStepCallback
}) => {
  const { t } = useTranslation();

  const {
    selectedBatteryId,
    newPercentage,
    setNewPercentage,
    selectedBatteryDistribution,
  } = useMoveVirtualBatteryContext();
  
  const { isWaitingChangeRequest } = useVirtualBatteries();
  
  return (
    <>
      <VirtualBatteryPercentageSlider
        value={newPercentage!}
        aria-labelledby="discrete-slider"
        step={1}
        min={0}
        max={100}
        onChange={(newValue) => setNewPercentage(newValue)}
        disabled={isWaitingChangeRequest}
      />

      {selectedBatteryDistribution && (
        <>
          <Typography variant="h6">
            {t("common:text.solar_wallet.move.destination_preview", {"batteryName": selectedBatteryDistribution.batteryName})}:
          </Typography>
          <BatteryDistributionPreview
            newPercentage={newPercentage!}
            selectedBatteryId={selectedBatteryId!}
            expectedAction="move"
          />
        </>
      )}
    </>
  );
};

export default MoveVirtualBatteryStep2;
